module.exports = __webpack_public_path__ + "img/trolley.514280f2.png";